import React, { useState, useEffect, useRef } from "react";
import { ThemeCtx, ToastCtx, api, SEV_C, STAT_C, PAGE_SIZE, Pager, Card, Modal, Bdg, Dot, Av, AdminBadge, useToast, ConfirmDialog, usePagination } from "../shared.js";

export function PageRemediation({user,myVulns}){
  var T=React.useContext(ThemeCtx).T;
  var PURPLE="#A100FF";
  var _tab=useState("findings"); var remTab=_tab[0]; var setRemTab=_tab[1];
  var _sort=useState({col:"priority",dir:"desc"}); var sort=_sort[0]; var setSort=_sort[1];
  var _filter=useState(""); var filter=_filter[0]; var setFilter=_filter[1];
  var _search=useState(""); var search=_search[0]; var setSearch=_search[1];

  var SEV_C={Critical:"#e5534b",High:"#e8892b",Medium:"#c69026",Low:"#2ea043"};
  var SLA_DAYS={Critical:7,High:30,Medium:60,Low:90};
  var _pwts=useState({cvss_weight:10,epss_weight:100,sla_weight:2,sev_critical:30,sev_high:20,sev_medium:10,sev_low:0,kev_boost:200,asset_critical_mult:150,asset_high_mult:125,asset_medium_mult:100,asset_low_mult:75,internet_mult:150});
  var pwts=_pwts[0]; var setPwts=_pwts[1];
  var _plan=useState(null);    var planData=_plan[0];    var setPlanData=_plan[1];
  var _patch=useState(null);   var patchData=_patch[0];  var setPatchData=_patch[1];
  var _impact=useState(null);  var impactData=_impact[0];var setImpactData=_impact[1];
  var _tracker=useState(null); var trackerData=_tracker[0];var setTrackerData=_tracker[1];
  var _tloading=useState(false);var tLoading=_tloading[0];var setTLoading=_tloading[1];
  var _tsync=useState("");     var syncMsg=_tsync[0];    var setSyncMsg=_tsync[1];
  useEffect(function(){
    api.get("/config").then(function(rows){
      var r=(rows||[]).find(function(x){return x.key==="priority_weights";});
      if(r){try{setPwts(JSON.parse(r.value));}catch(e){}}
    }).catch(function(){});
  },[]);
  useEffect(function(){
    if(remTab==="plan")    api.get("/remediation/plan").then(setPlanData).catch(function(){});
    if(remTab==="patch")   api.get("/remediation/patch-planner").then(setPatchData).catch(function(){});
    if(remTab==="impact")  api.get("/remediation/patch-impact").then(setImpactData).catch(function(){});
    if(remTab==="tracker") api.get("/remediation/tracker").then(setTrackerData).catch(function(){});
  },[remTab]);
  var calcPriority=function(v){
    var cvss=parseFloat(v.cvss)||5;
    var epss=parseFloat(v.epss)||0.1;
    var daysLeft=v.days_left||0;
    var overduePts=daysLeft<0?Math.min(Math.abs(daysLeft)*pwts.sla_weight,40):0;
    var sevPts={Critical:pwts.sev_critical,High:pwts.sev_high,Medium:pwts.sev_medium,Low:pwts.sev_low}[v.severity]||0;
    var baseScore=cvss*pwts.cvss_weight+epss*pwts.epss_weight+overduePts+sevPts;
    // Phase 1: KEV boost
    var kevBoost=v.kev?(pwts.kev_boost||200):0;
    // Phase 1: Asset criticality multiplier
    var assetCritMult=({Critical:(pwts.asset_critical_mult||150),High:(pwts.asset_high_mult||125),Medium:(pwts.asset_medium_mult||100),Low:(pwts.asset_low_mult||75)}[v.asset_criticality]||100)/100;
    // Phase 2: Sensitive data + regulatory additive
    var sensAdd=({PII:0.5,Financial:0.3,IP:0.2,None:0}[v.sensitive_data]||0);
    var regAdd=({PCI:0.3,HIPAA:0.3,ISO:0.1,SOC2:0.1,None:0}[v.regulatory_scope]||0);
    var bizMult=Math.min(assetCritMult+sensAdd+regAdd,2.0);
    // Phase 2: Internet exposure multiplier
    var exposureMult=v.internet_facing?((pwts.internet_mult||150)/100):1.0;
    // Phase 2: Compensating controls deduction
    var controls=Array.isArray(v.asset_controls)?v.asset_controls:[];
    var ctrlDeduct=controls.reduce(function(sum,c){
      return sum+({WAF:0.10,EDR:0.10,NET_ISOLATION:0.15,MFA:0.05,IPS:0.10,ENCRYPTION:0.05,PAM:0.05}[c]||0);
    },0);
    var ctrlMult=Math.max(1.0-ctrlDeduct,0.5);
    var score=Math.round((baseScore+kevBoost)*bizMult*exposureMult*ctrlMult);
    return Math.min(score,1000);
  };

  // Memoize priority scoring — only recalc when vulns or weights change
  var scoredVulns=React.useMemo(function(){
    return myVulns
      .filter(function(v){return v.status!=="Remediated"&&v.status!=="Exception";})
      .map(function(v){return Object.assign({},v,{priority:calcPriority(v)});});
  },[myVulns,pwts]);

  var filtered=React.useMemo(function(){
    return scoredVulns.filter(function(v){
      if(filter&&v.severity!==filter) return false;
      if(search&&!(v.id+v.title+v.asset+(v.owner_name||"")).toLowerCase().includes(search.toLowerCase())) return false;
      return true;
    });
  },[scoredVulns,filter,search]);

  var sorted=React.useMemo(function(){
    return filtered.slice().sort(function(a,b){
      var av=a[sort.col],bv=b[sort.col];
      if(av==null)av=0; if(bv==null)bv=0;
      if(typeof av==="string") return sort.dir==="asc"?av.localeCompare(bv):bv.localeCompare(av);
      return sort.dir==="asc"?av-bv:bv-av;
    });
  },[filtered,sort]);

  var toggleSort=function(col){setSort(function(s){return s.col===col?{col:col,dir:s.dir==="asc"?"desc":"asc"}:{col:col,dir:"desc"};});};

  var getPriorityColor=function(score){
    return score>=700?"#e5534b":score>=400?"#e8892b":score>=200?"#c69026":"#2ea043";
  };

  var thS={padding:"9px 12px",textAlign:"left",fontSize:10,fontWeight:700,color:T.text3,
    textTransform:"uppercase",letterSpacing:.8,background:T.inset,
    borderBottom:"1px solid "+T.border,whiteSpace:"nowrap",cursor:"pointer",userSelect:"none"};
  var tdS={padding:"9px 12px",fontSize:12,borderBottom:"1px solid "+T.border,verticalAlign:"middle"};

  // Summary cards
  var buckets=[
    {l:"Critical — 7d",c:"#e5534b",items:scoredVulns.filter(function(v){return v.severity==="Critical";})},
    {l:"High — 30d",   c:"#e8892b",items:scoredVulns.filter(function(v){return v.severity==="High";})},
    {l:"Overdue",      c:"#d29922",items:scoredVulns.filter(function(v){return (v.days_left||0)<0;})},
    {l:"Due ≤7d",      c:"#c69026",items:scoredVulns.filter(function(v){return (v.days_left||0)>=0&&(v.days_left||0)<=7;})},
  ];

  return React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:12}},

    // Tab bar
    React.createElement("div",{style:{display:"flex",borderBottom:"1px solid "+T.border,gap:0,marginBottom:4}},
      [["findings","Priority Findings"],["campaigns","Campaigns"],
       ["plan","30-60-90 Plan"],["patch","Patch Planner"],
       ["impact","Patch Impact"],["tracker","Tracker"]].map(function(t){
        return React.createElement("button",{key:t[0],onClick:function(){setRemTab(t[0]);},
          style:{padding:"10px 18px",background:"transparent",border:"none",
            borderBottom:remTab===t[0]?"2px solid "+PURPLE:"2px solid transparent",
            color:remTab===t[0]?PURPLE:T.text3,cursor:"pointer",fontSize:12,
            fontWeight:remTab===t[0]?700:400,whiteSpace:"nowrap"}},t[1]);
      })
    ),
    remTab==="campaigns"&&React.createElement(PageCampaigns,{user:user,myVulns:myVulns}),

    // ── 30-60-90 Plan ──────────────────────────────────────────────────────
    remTab==="plan"&&React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:12}},
      !planData&&React.createElement("div",{style:{color:T.text3,textAlign:"center",padding:40}},"Loading..."),
      planData&&React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:10}},
        [
          {label:"OVERDUE — Immediate Action",color:"#e5534b",bg:"#2d1515",items:(planData.overdue||[])},
          {label:"0-30 Days — This Month",    color:"#e8892b",bg:"#2d1e10",items:(planData.days30||[])},
          {label:"31-60 Days — Next Month",   color:"#c69026",bg:"#2a2010",items:(planData.days60||[])},
          {label:"61-90 Days — Quarter",      color:"#388bfd",bg:"#0e1e35",items:(planData.days90||[])},
          {label:"90+ Days — Monitor",        color:"#64748b",bg:T.inset,  items:(planData.beyond||[])},
        ].map(function(bucket){
          if(!bucket.items.length) return null;
          return React.createElement("div",{key:bucket.label,style:{background:T.card,border:"1px solid "+T.border,borderRadius:10,overflow:"hidden"}},
            React.createElement("div",{style:{background:bucket.color,padding:"8px 14px",display:"flex",justifyContent:"space-between",alignItems:"center"}},
              React.createElement("span",{style:{color:"#fff",fontWeight:700,fontSize:13}},bucket.label),
              React.createElement("span",{style:{color:"#fff",fontSize:12,opacity:.85}},bucket.items.length+" items")
            ),
            React.createElement("table",{style:{width:"100%",borderCollapse:"collapse"}},
              React.createElement("thead",null,
                React.createElement("tr",{style:{background:T.inset}},
                  ["ID","Severity","Title","Asset","Owner","Pod","Days"].map(function(h){
                    return React.createElement("th",{key:h,style:{padding:"7px 12px",fontSize:10,fontWeight:700,color:T.text3,textAlign:"left",textTransform:"uppercase",letterSpacing:.8}},h);
                  })
                )
              ),
              React.createElement("tbody",null,
                bucket.items.slice(0,PAGE_SIZE).map(function(v,i){
                  return React.createElement("tr",{key:v.id,style:{borderTop:"1px solid "+T.border,background:i%2===0?"transparent":T.inset+"44"}},
                    React.createElement("td",{style:{padding:"7px 12px",fontSize:11,fontWeight:700,color:PURPLE}},v.id),
                    React.createElement("td",{style:{padding:"7px 12px"}},
                      React.createElement("span",{style:{background:({Critical:"#e5534b",High:"#e8892b",Medium:"#c69026",Low:"#2ea043"}[v.severity]||"#888")+"22",color:({Critical:"#e5534b",High:"#e8892b",Medium:"#c69026",Low:"#2ea043"}[v.severity]||"#888"),padding:"2px 8px",borderRadius:20,fontSize:11,fontWeight:700}},v.severity)
                    ),
                    React.createElement("td",{style:{padding:"7px 12px",fontSize:12,color:T.text,maxWidth:220,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}},v.title),
                    React.createElement("td",{style:{padding:"7px 12px",fontSize:11,color:T.text2}},v.asset),
                    React.createElement("td",{style:{padding:"7px 12px",fontSize:11,color:T.text2}},v.owner_name||"—"),
                    React.createElement("td",{style:{padding:"7px 12px",fontSize:11,color:T.text2}},v.pod_name||"—"),
                    React.createElement("td",{style:{padding:"7px 12px",fontSize:11,fontWeight:700,color:v.days_left<0?"#e5534b":v.days_left<=7?"#c69026":"#2ea043"}},
                      v.days_left<0?Math.abs(v.days_left)+"d over":v.days_left+"d left")
                  );
                })
              )
            )
          );
        })
      )
    ),

    // ── Patch Planner ──────────────────────────────────────────────────────
    remTab==="patch"&&React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:10}},
      React.createElement("div",{style:{fontSize:13,color:T.text2,marginBottom:4}},
        "Group vulnerabilities by patch/KB — find the most efficient remediation path"),
      !patchData&&React.createElement("div",{style:{color:T.text3,textAlign:"center",padding:40}},"Loading..."),
      patchData&&React.createElement("div",{style:{background:T.card,border:"1px solid "+T.border,borderRadius:10,overflow:"hidden"}},
        React.createElement("table",{style:{width:"100%",borderCollapse:"collapse",tableLayout:"fixed"}},
          React.createElement("thead",null,
            React.createElement("tr",{style:{background:T.inset}},
              [["QID / Rule","14%"],["Title","22%"],["Sev","8%"],["Fix Type","12%"],
               ["Findings","7%"],["CVEs","12%"],["Pending KB","10%"],["Version","8%"],["Link","7%"]].map(function(h){
                return React.createElement("th",{key:h[0],style:{padding:"9px 10px",fontSize:10,fontWeight:700,color:T.text3,textAlign:"left",textTransform:"uppercase",letterSpacing:.8,width:h[1],borderBottom:"1px solid "+T.border}},h[0]);
              })
            )
          ),
          React.createElement("tbody",null,
            (patchData||[]).slice(0,PAGE_SIZE).map(function(r,i){
              var sc={Critical:"#e5534b",High:"#e8892b",Medium:"#c69026",Low:"#2ea043"}[r.severity]||"#888";
              var ftc={
                "Patch (KB)":"#388bfd","Version Upgrade":"#8957e5","Registry Change":"#e8892b",
                "Configuration Change":"#2ea043","Uninstall / EOL":"#e5534b",
                "Mitigation / No Patch":"#c69026","Patch / Update":"#58a6ff","Review / Other":"#64748b"
              }[r.fix_type]||"#888";
              return React.createElement("tr",{key:r.qid+i,style:{borderTop:"1px solid "+T.border,background:i%2===0?"transparent":T.inset+"44"}},
                React.createElement("td",{style:{padding:"8px 10px",fontSize:11,fontWeight:700,color:PURPLE,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"},title:r.title||r.qid||""},r.qid||"—"),
                React.createElement("td",{style:{padding:"8px 10px",fontSize:11,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",color:T.text}},r.title),
                React.createElement("td",{style:{padding:"8px 10px"}},
                  React.createElement("span",{style:{background:sc+"22",color:sc,padding:"2px 6px",borderRadius:12,fontSize:10,fontWeight:700}},r.severity?.slice(0,4))
                ),
                React.createElement("td",{style:{padding:"8px 10px"}},
                  React.createElement("span",{style:{background:ftc+"22",color:ftc,padding:"2px 6px",borderRadius:6,fontSize:10,fontWeight:600,whiteSpace:"nowrap"}},r.fix_type)
                ),
                React.createElement("td",{style:{padding:"8px 10px",fontSize:12,fontWeight:700,color:T.text,textAlign:"center"}},r.findings),
                React.createElement("td",{style:{padding:"8px 10px",fontSize:10,color:T.text2,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}},r.cves||"—"),
                React.createElement("td",{style:{padding:"8px 10px",fontSize:11,fontWeight:600,color:"#388bfd"}},r.pending_kb||"—"),
                React.createElement("td",{style:{padding:"8px 10px",fontSize:11,color:T.text2}},r.fix_version||"—"),
                React.createElement("td",{style:{padding:"8px 10px",fontSize:11}},
                  r.ref_link?React.createElement("a",{href:r.ref_link,target:"_blank",style:{color:PURPLE,textDecoration:"none",fontSize:10}},"Link ↗"):React.createElement("span",{style:{color:T.text3}},"—")
                )
              );
            })
          )
        )
      )
    ),

    // ── Patch Impact ───────────────────────────────────────────────────────
    remTab==="impact"&&React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:10}},
      React.createElement("div",{style:{fontSize:13,color:T.text2,marginBottom:4}},
        "Which single patch gives the biggest risk reduction?"),
      !impactData&&React.createElement("div",{style:{color:T.text3,textAlign:"center",padding:40}},"Loading..."),
      impactData&&impactData.length===0&&React.createElement("div",{style:{background:T.card,border:"1px solid "+T.border,borderRadius:10,padding:40,textAlign:"center",color:T.text3}},
        "No KB patches detected yet. Import Qualys or Tenable findings with solution text to see patch impact."
      ),
      impactData&&impactData.length>0&&React.createElement("div",{style:{background:T.card,border:"1px solid "+T.border,borderRadius:10,overflow:"hidden"}},
        React.createElement("table",{style:{width:"100%",borderCollapse:"collapse"}},
          React.createElement("thead",null,
            React.createElement("tr",{style:{background:T.inset}},
              [["Patch / KB","20%"],["Findings Fixed","16%"],["Critical","12%"],["High","12%"],["Components","40%"]].map(function(h){
                return React.createElement("th",{key:h[0],style:{padding:"9px 14px",fontSize:10,fontWeight:700,color:T.text3,textAlign:"left",textTransform:"uppercase",letterSpacing:.8,width:h[1],borderBottom:"1px solid "+T.border}},h[0]);
              })
            )
          ),
          React.createElement("tbody",null,
            impactData.map(function(r,i){
              return React.createElement("tr",{key:r.patch_kb,style:{borderTop:"1px solid "+T.border,background:i%2===0?"transparent":T.inset+"44"}},
                React.createElement("td",{style:{padding:"9px 14px",fontSize:13,fontWeight:700,color:"#388bfd"}},r.patch_kb),
                React.createElement("td",{style:{padding:"9px 14px",fontSize:20,fontWeight:800,color:PURPLE}},r.findings_fixed),
                React.createElement("td",{style:{padding:"9px 14px"}},
                  r.critical>0&&React.createElement("span",{style:{background:"#e5534b22",color:"#e5534b",padding:"2px 8px",borderRadius:12,fontSize:11,fontWeight:700}},r.critical)
                ),
                React.createElement("td",{style:{padding:"9px 14px"}},
                  r.high>0&&React.createElement("span",{style:{background:"#e8892b22",color:"#e8892b",padding:"2px 8px",borderRadius:12,fontSize:11,fontWeight:700}},r.high)
                ),
                React.createElement("td",{style:{padding:"9px 14px",fontSize:11,color:T.text2}},r.components||"—")
              );
            })
          )
        )
      )
    ),

    // ── Tracker ────────────────────────────────────────────────────────────
    remTab==="tracker"&&React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:12}},
      // MTTR + summary cards
      React.createElement("div",{style:{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(120px,1fr))",gap:10}},
        [
          {l:"Open",       v:trackerData?.open_total||0,     c:"#388bfd"},
          {l:"Overdue",    v:trackerData?.overdue_total||0,   c:"#e5534b"},
          {l:"Mitigated",  v:trackerData?.mitigated_total||0, c:"#2ea043"},
          {l:"MTTR (days)",v:trackerData?.mttr_days!=null?trackerData.mttr_days+"d":"—",c:PURPLE},
        ].map(function(k){
          return React.createElement("div",{key:k.l,style:{background:T.card,border:"1px solid "+T.border,borderRadius:10,padding:"14px 16px",textAlign:"center"}},
            React.createElement("div",{style:{fontSize:28,fontWeight:800,color:k.c}},k.v),
            React.createElement("div",{style:{fontSize:11,color:T.text3,marginTop:4}},k.l)
          );
        })
      ),
      // Sync button
      React.createElement("div",{style:{display:"flex",alignItems:"center",gap:10}},
        React.createElement("button",{
          onClick:async function(){
            setTLoading(true);setSyncMsg("");
            try{
              var r=await api.post("/remediation/tracker/sync",{});
              setSyncMsg("Sync complete — "+r.new+" new, "+r.mitigated+" mitigated, "+r.reopened+" reopened");
              var d=await api.get("/remediation/tracker");setTrackerData(d);
            }catch(e){setSyncMsg("Error: "+e.message);}
            setTLoading(false);
          },
          style:{background:PURPLE,color:"#fff",border:"none",borderRadius:8,padding:"8px 18px",cursor:"pointer",fontSize:12,fontWeight:600,opacity:tLoading?0.6:1}
        },tLoading?"⏳ Syncing...":"↺ Sync from Vulns"),
        syncMsg&&React.createElement("span",{style:{fontSize:12,color:T.text2}},syncMsg)
      ),
      // Owner breakdown
      trackerData&&(trackerData.owner_breakdown||[]).length>0&&React.createElement("div",{style:{background:T.card,border:"1px solid "+T.border,borderRadius:10,overflow:"hidden"}},
        React.createElement("div",{style:{padding:"10px 14px",fontSize:12,fontWeight:700,color:T.text,borderBottom:"1px solid "+T.border}},"Owner Breakdown"),
        React.createElement("table",{style:{width:"100%",borderCollapse:"collapse"}},
          React.createElement("thead",null,
            React.createElement("tr",{style:{background:T.inset}},
              ["Owner","Open","Overdue","Mitigated"].map(function(h){
                return React.createElement("th",{key:h,style:{padding:"8px 14px",fontSize:10,fontWeight:700,color:T.text3,textAlign:"left",textTransform:"uppercase",letterSpacing:.8,borderBottom:"1px solid "+T.border}},h);
              })
            )
          ),
          React.createElement("tbody",null,
            (trackerData.owner_breakdown||[]).map(function(o,i){
              return React.createElement("tr",{key:o.owner,style:{borderTop:"1px solid "+T.border,background:i%2===0?"transparent":T.inset+"44"}},
                React.createElement("td",{style:{padding:"8px 14px",fontSize:12,fontWeight:600,color:T.text}},o.owner),
                React.createElement("td",{style:{padding:"8px 14px",fontSize:12,color:"#388bfd",fontWeight:700}},o.open),
                React.createElement("td",{style:{padding:"8px 14px",fontSize:12,color:o.overdue>0?"#e5534b":T.text3,fontWeight:o.overdue>0?700:400}},o.overdue),
                React.createElement("td",{style:{padding:"8px 14px",fontSize:12,color:"#2ea043",fontWeight:700}},o.mitigated)
              );
            })
          )
        )
      ),
      // Tracker rows
      trackerData&&React.createElement("div",{style:{background:T.card,border:"1px solid "+T.border,borderRadius:10,overflow:"hidden"}},
        React.createElement("div",{style:{padding:"10px 14px",fontSize:12,fontWeight:700,color:T.text,borderBottom:"1px solid "+T.border}},"Finding Status"),
        React.createElement("table",{style:{width:"100%",borderCollapse:"collapse"}},
          React.createElement("thead",null,
            React.createElement("tr",{style:{background:T.inset}},
              ["Identifier","Title","Asset","Owner","Severity","Due","Status"].map(function(h){
                return React.createElement("th",{key:h,style:{padding:"8px 12px",fontSize:10,fontWeight:700,color:T.text3,textAlign:"left",textTransform:"uppercase",letterSpacing:.8,borderBottom:"1px solid "+T.border}},h);
              })
            )
          ),
          React.createElement("tbody",null,
            (trackerData.rows||[]).slice(0,50).map(function(r,i){
              var sc={Open:"#388bfd",Overdue:"#e5534b",Mitigated:"#2ea043",Reopened:"#c69026"}[r.status]||"#888";
              return React.createElement("tr",{key:r.id||i,style:{borderTop:"1px solid "+T.border,background:i%2===0?"transparent":T.inset+"44"}},
                React.createElement("td",{style:{padding:"7px 12px",fontSize:11,fontWeight:700,color:PURPLE}},r.identifier||"—"),
                React.createElement("td",{style:{padding:"7px 12px",fontSize:11,color:T.text,maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}},r.title||"—"),
                React.createElement("td",{style:{padding:"7px 12px",fontSize:11,color:T.text2}},r.asset||"—"),
                React.createElement("td",{style:{padding:"7px 12px",fontSize:11,color:T.text2}},r.owner||"—"),
                React.createElement("td",{style:{padding:"7px 12px",fontSize:11,fontWeight:600,color:({Critical:"#e5534b",High:"#e8892b",Medium:"#c69026",Low:"#2ea043"}[r.severity])||"#888"}},r.severity||"—"),
                React.createElement("td",{style:{padding:"7px 12px",fontSize:11,color:r.status==="Overdue"?"#e5534b":T.text2}},r.due_date||"—"),
                React.createElement("td",{style:{padding:"7px 12px"}},
                  React.createElement("span",{style:{background:sc+"22",color:sc,padding:"2px 8px",borderRadius:12,fontSize:11,fontWeight:600}},r.status)
                )
              );
            })
          )
        )
      )
    ),

    remTab==="findings"&&React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:12}},

    // Summary cards
    React.createElement("div",{style:{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(120px,1fr))",gap:10}},
      buckets.map(function(b){
        return React.createElement("div",{key:b.l,
          onClick:function(){setFilter(filter===b.l.split(" ")[0]?"":b.l.split(" ")[0]);},
          style:{background:T.card,border:"2px solid "+(filter===b.l.split(" ")[0]?b.c:T.border),
            borderRadius:12,padding:"14px 16px",cursor:"pointer",boxShadow:T.cardShadow}},
          React.createElement("div",{style:{fontSize:24,fontWeight:800,color:b.c}},b.items.length),
          React.createElement("div",{style:{fontSize:11,color:T.text3,marginTop:2}},b.l)
        );
      })
    ),

    // Filters
    React.createElement("div",{style:{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}},
      React.createElement("input",{placeholder:"Search ID, title, asset...",value:search,
        onChange:function(e){setSearch(e.target.value);},
        style:{flex:"1 1 200px",padding:"8px 12px",background:T.inset,border:"1px solid "+T.border,
          color:T.text,fontSize:12,outline:"none",borderRadius:8}}),
      React.createElement("select",{value:filter,onChange:function(e){setFilter(e.target.value);},
        style:{padding:"7px 10px",background:T.inset,border:"1px solid "+T.border,color:T.text,fontSize:12,outline:"none",borderRadius:8}},
        React.createElement("option",{value:""},"All Severities"),
        ["Critical","High","Medium","Low"].map(function(s){
          return React.createElement("option",{key:s,value:s},s);
        })
      ),
      React.createElement("div",{style:{fontSize:12,color:T.text3}},sorted.length+" items")
    ),

    // Table
    React.createElement("div",{style:{background:T.card,borderRadius:12,overflow:"hidden",boxShadow:T.cardShadow}},
      React.createElement("table",{style:{width:"100%",borderCollapse:"collapse"}},
        React.createElement("thead",null,
          React.createElement("tr",null,
            [["priority","Priority Score",100],["id","ID",80],["severity","Severity",90],
             ["title","Title",160],["asset","Asset",120],["owner_name","Owner",100],
             ["status","Status",110],["days_left","SLA",80],["cvss","CVSS",70],["epss","EPSS",70]
            ].map(function(h){
              return React.createElement("th",{key:h[0],style:Object.assign({},thS,{width:h[2]}),
                onClick:function(){toggleSort(h[0]);}},
                h[1],sort.col===h[0]?React.createElement("span",{style:{color:PURPLE,marginLeft:3}},sort.dir==="asc"?" ↑":" ↓"):"");
            })
          )
        ),
        React.createElement("tbody",null,
          sorted.length===0
            ? React.createElement("tr",null,React.createElement("td",{colSpan:10,style:{padding:40,textAlign:"center",color:T.text3}},"No items"))
            : sorted.map(function(v,i){
                var sc=SEV_C[v.severity]||T.text3;
                var pc=getPriorityColor(v.priority);
                var overdue=(v.days_left||0)<0;
                return React.createElement("tr",{key:v.id,
                  style:{background:i%2===0?T.card:T.inset}},
                  // Priority score
                  React.createElement("td",{style:tdS},
                    React.createElement("div",{style:{display:"flex",alignItems:"center",gap:6}},
                      React.createElement("div",{style:{position:"relative"}},
                        React.createElement("div",{style:{width:36,height:36,borderRadius:"50%",
                          background:pc+"20",border:"2px solid "+pc,
                          display:"flex",alignItems:"center",justifyContent:"center",
                          fontSize:11,fontWeight:800,color:pc}},v.priority),
                        v.kev&&React.createElement("div",{title:"CISA Known Exploited Vulnerability",
                          style:{position:"absolute",top:-4,right:-4,width:14,height:14,
                          borderRadius:"50%",background:"#DC2626",display:"flex",
                          alignItems:"center",justifyContent:"center",
                          fontSize:8,fontWeight:800,color:"#fff",border:"1px solid #fff"}},"K")
                      ),
                      React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:2}},
                        React.createElement("div",{style:{width:50,height:4,background:T.border,borderRadius:4}},
                          React.createElement("div",{style:{width:(v.priority/10)+"%",height:"100%",background:pc,borderRadius:4}})
                        ),
                        v.asset_criticality&&React.createElement("div",{style:{fontSize:9,color:T.text3}},
                          "Asset: ",React.createElement("span",{style:{fontWeight:600,
                          color:({Critical:"#e5534b",High:"#e8892b",Medium:"#c69026",Low:"#2ea043"}[v.asset_criticality])||T.text3}},
                          v.asset_criticality))
                      )
                    )
                  ),
                  React.createElement("td",{style:Object.assign({},tdS,{fontWeight:700,color:PURPLE,fontSize:11})},v.id),
                  React.createElement("td",{style:tdS},
                    React.createElement("span",{style:{background:sc+"20",color:sc,padding:"2px 8px",borderRadius:20,fontSize:11,fontWeight:700}},v.severity)
                  ),
                  React.createElement("td",{style:Object.assign({},tdS,{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",maxWidth:160})},v.title),
                  React.createElement("td",{style:Object.assign({},tdS,{color:T.text2,fontSize:11})},v.asset),
                  React.createElement("td",{style:Object.assign({},tdS,{color:T.text2,fontSize:11})},v.owner_name||"—"),
                  React.createElement("td",{style:tdS},
                    React.createElement("span",{style:{background:T.inset,color:T.text2,padding:"2px 8px",borderRadius:20,fontSize:11,border:"1px solid "+T.border}},v.status)
                  ),
                  React.createElement("td",{style:Object.assign({},tdS,{fontWeight:600,fontSize:11,
                    color:overdue?"#e5534b":(v.days_left||0)<=3?"#d29922":"#2ea043"})},
                    overdue?Math.abs(v.days_left||0)+"d over":(v.days_left||0)+"d left"),
                  React.createElement("td",{style:Object.assign({},tdS,{color:T.text3,fontSize:11})},v.cvss||"—"),
                  React.createElement("td",{style:Object.assign({},tdS,{color:T.text3,fontSize:11})},v.epss||"—")
                );
              })
        )
      )
    )
  ));
}